import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebAngularSharedDataAccessFeatureFlagApisService } from './services/feature-flags.service';
import { StoreModule } from '@ngrx/store';
import { fromFeatureFlags } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { WebAngularSharedDataAccessFeatureFlagApiEffects } from '../lib/effects/feature-flag.effects';
import { IfFeatureFlagEnabledDirective } from './directives/if-feature-flag-enabled.directive';
import { IfFeatureFlagEnabledAsyncDirective } from './directives/if-feature-flag-enabled-async.directive';
import { IfFeatureFlagDisabledDirective } from './directives/if-feature-flag-disabled.directive';
import { IfFeatureFlagDisbaledAsyncDirective } from './directives/if-feature-flag-disabled-async.directive';
import { WebAngularSharedDataAccessFeatureFlagApiGuard, MaintenanceGuard } from './guards';

@NgModule({
  declarations: [
    IfFeatureFlagEnabledDirective,
    IfFeatureFlagEnabledAsyncDirective,
    IfFeatureFlagDisabledDirective,
    IfFeatureFlagDisbaledAsyncDirective,
  ],
  imports: [
    CommonModule,
    EffectsModule.forFeature([WebAngularSharedDataAccessFeatureFlagApiEffects]),
    StoreModule.forFeature('featureFlags', fromFeatureFlags.featureFlagsReducer),
    EffectsModule.forFeature([WebAngularSharedDataAccessFeatureFlagApiEffects]),
  ],
  providers: [
    WebAngularSharedDataAccessFeatureFlagApiGuard,
    MaintenanceGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: initFlagServiceFactory,
      deps: [WebAngularSharedDataAccessFeatureFlagApisService],
      multi: true,
    },
  ],
  exports: [
    IfFeatureFlagEnabledDirective,
    IfFeatureFlagEnabledAsyncDirective,
    IfFeatureFlagDisabledDirective,
    IfFeatureFlagDisbaledAsyncDirective,
  ],
})
export class WebAngularSharedDataAccessFeatureFlagApiModule {}


export function initFlagServiceFactory(
  featureFlagSvc: WebAngularSharedDataAccessFeatureFlagApisService
) {
  return async () => {
    await featureFlagSvc.configureClient();
  };
}
